<template>
  <div class="help">
    <div class="tway-title-hero"></div>
    <v-container>
      <div class="mb-9 tway-headline-2 text-center tway-morado--text">Sobre Tway</div>
      <div class="mb-9">
        <v-layout row>
          <v-flex :class="mobile ? 'mb-5' : 'px-4'" xs12 md3>
            <v-layout>
              <v-img
                :src="require('@/assets/images/tway-platform.svg')"
                contain
                width="200"
                max-height="140"
              />
            </v-layout>
          </v-flex>
          <v-flex :class="mobile ? 'px-4' : ''" xs12 md9>
            <div class="tway-headline-3 mb-3">¿Qué es Tway?</div>
            <div class="tway-body grey--text text--darken-3">Tway es un marketplace y punto de encuentro para las empresas de todo tamaño que ofrezcan y requieran servicios, productos y soluciones especializadas en transformación digital, generando nuevos canales de venta, negocios, conocimiento y networking entre los usuarios.</div>
          </v-flex>
        </v-layout>
      </div>
      <div class="mb-9">
        <v-layout row>
          <v-flex :class="mobile ? 'mb-5' : 'px-4'" xs12 md3 order-md2>
            <v-layout>
              <v-img
                :src="require('@/assets/images/companies.svg')"
                contain
                width="210"
                max-height="120"
              />
            </v-layout>
          </v-flex>
          <v-flex :class="mobile ? 'px-4' : ''" xs12 md9 order-md1>
            <div :class="mobile ? '' : 'text-right'" class="tway-headline-3 mb-3">¿A quiénes está dirigida esta plataforma?</div>
            <div
              :class="mobile ? '' : 'text-right'"
              class="tway-body grey--text text--darken-3"
            >Tway está pensado para que micro, pequeñas, medianas y grandes empresas utilicen esta plataforma para avanzar en la transformación digital a través de la contratación o venta de soluciones específicas, ponerse en contacto con socios estratégicos, recibir reportes, benchmark, tendencias y contenidos en transformación y mejorar sus indicadores de transformación, innovación y productividad.</div>
          </v-flex>
        </v-layout>
      </div>
      <div class="mb-9">
        <v-layout row>
          <v-flex :class="mobile ? 'mb-5' : 'px-4'" xs12 md3>
            <v-layout>
              <v-img
                :src="require('@/assets/images/working-chat.svg')"
                contain
                width="200"
                max-height="140"
              />
            </v-layout>
          </v-flex>
          <v-flex :class="mobile ? 'px-4' : ''" xs12 md9>
            <div class="tway-headline-3 mb-3">¿Qué beneficios ofrece?</div>
            <div
              class="tway-body grey--text text--darken-3"
            >Tway conecta con nuevos clientes y negocios, rankea a los especialistas para validar sus servicios y acercarlos en forma directa a las empresas que buscan soluciones especializadas, genera contenidos exclusivos sobre transformación estratégica a diario, entrega diagnóstico de estado de madurez digital a proveedores y el indicador de madurez digital a las empresas para dar visibilidad de las brechas y darle un conjunto de alternativas para avanzar en su transformación, entre otros beneficios de ser suscriptor de la plataforma.</div>
          </v-flex>
        </v-layout>
      </div>
      <div class="mb-9">
        <v-layout row>
          <v-flex :class="mobile ? 'mb-5' : 'px-4'" xs12 md3 order-md2>
            <v-layout>
              <v-img
                :src="require('@/assets/images/especialistas.svg')"
                contain
                width="260"
                max-height="190"
              />
            </v-layout>
          </v-flex>
          <v-flex :class="mobile ? 'px-4' : ''" xs12 md9 order-md1>
            <div :class="mobile ? '' : 'text-right'" class="tway-headline-3 mb-3">¿Cómo funciona?</div>
            <div :class="mobile ? '' : 'text-right'" class="tway-body grey--text text--darken-3">
              <p>Tway reúne en un mismo espacio digital a los socios estratégicos más relevantes del mercado para conectar a quienes buscan soluciones en transformación digital y las empresas que las ofrecen.</p>
              <p>Para realizar este calce inteligente entre necesidades reales y ofertas perfiladas por criterios de calidad y estado de madurez digital, desarrollamos un sistema de modelamiento, análisis de datos y automatización, lo que optimiza la búsqueda, disminuye el nivel de riesgo, genera eficiencias y hace más productiva la toma de decisiones.</p>
              <p>Para esto es clave el indicador IM (Índice de Madurez), que monitorea el estado actual de la madurez digital de cada compañía y el avance de nuestros usuarios durante su suscripción a la plataforma.</p>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
    <div class="tway-waves tway-waves-white-up"></div>
    <div class="how-to-begin">
      <v-container>
        <div class="mb-9 tway-headline-2 text-center tway-morado--text">Para comenzar</div>
        <div class="mb-9">
          <v-layout row>
            <v-flex :class="mobile ? 'mb-5' : 'px-4'" xs12 md3>
              <v-layout>
                <v-img
                  :src="require('@/assets/images/user-computer.svg')"
                  contain
                  width="280"
                  max-height="120"
                />
              </v-layout>
            </v-flex>
            <v-flex :class="mobile ? 'px-4' : ''" xs12 md9>
              <div class="tway-headline-3 mb-3">¿Cómo empiezo?</div>
              <div class="tway-body grey--text text--darken-3">
                <p>
                  Ingresa a
                  <a href="https://www.tway.cl">www.tway.cl</a> y dirígete a la pestaña PLANES. Allí podrás encontrar las opciones para Especialista o Cliente y los distintos planes a la medida. Escoge el que más se ajusta a tu empresa y dirígete a la sección de pago.
                </p>
                <p>Ahora comienza a disfrutar la experiencia Tway para crecer en la transformación estratégica de tu negocio.</p>
              </div>
            </v-flex>
          </v-layout>
        </div>
        <div class="mb-9">
          <v-layout row>
            <v-flex :class="mobile ? 'mb-5' : 'px-4'" xs12 md3 order-md2>
              <v-layout>
                <v-img
                  :src="require('@/assets/images/cliente-o-proveedor.svg')"
                  contain
                  width="230"
                  max-height="150"
                />
              </v-layout>
            </v-flex>
            <v-flex :class="mobile ? 'px-4' : ''" xs12 md9 order-md1>
              <div :class="mobile ? '' : 'text-right'" class="tway-headline-3 mb-3">¿Cómo sé si soy Especialista o Cliente?</div>
              <div :class="mobile ? '' : 'text-right'" class="tway-body grey--text text--darken-3">
                <p>Eres Especialista si provees servicios, productos o herramientas específicos para suplir necesidades de transformación digital en las siguientes categorías de servicio: acceso remoto y movilidad, big data y análisis de data, estrategia y modelos de negocio, consultoría, contenido y creatividad digital, cyberseguridad, diseño de productos y servicios, inteligencia artificial, IoT, software y hardware, experiencia clientes, headhunters, marketing y comunicación omnicanal, organización, liderazgo y cultura; optimización procesos y automatización, herramientas de innovación, entre otros.</p>
                <p>Eres Cliente si tu empresa requiere servicios, productos o herramientas confiables para adaptar tu negocio a la transformación digital.</p>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </div>
    <div class="tway-waves tway-waves-white-down tway-waves-bottom tway-waves-reflect"></div>
    <div class="about-plans">
      <v-container>
        <div
          class="tway-headline-2 text-center tway-morado--text"
          id="planes"
          style="margin-bottom: 30px;"
        >
          Sobre los planes
        </div>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="tway-font-expansion-panel">
              ¿Qué incluye en Plan Starter?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="tway-body text-left py-3 grey--text text--darken-3">
                Al acceder al Plan Starter recibirás una selección de los mejores contenidos y tendencias en transformación digital. Un repertorio de notas de actualidad, buenas prácticas nacionales e internacionales, entrevistas a quienes que están transformando sus empresas y conocimiento específico para navegar en la economía digital. Te ayudamos a hacer este camino de forma amena e informada.
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="tway-font-expansion-panel">
              Soy Especialista y estoy en el Plan Starter, ¿Cómo puedo suscribirme al Plan Best Fit?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <v-layout row>
                  <v-flex :class="mobile ? 'mb-5' : 'px-4'" xs12 md3>
                    <v-layout>
                      <v-img
                        :src="require('@/assets/images/especialista.svg')"
                        contain
                        width="200"
                        max-height="140"
                      />
                    </v-layout>
                  </v-flex>
                  <v-flex :class="mobile ? 'px-4' : ''" xs12 md9>
                    <div class="tway-body grey--text text--darken-3">
                      <p>El Plan Best Fit es el paquete de beneficios más completo en Tway y estará disponible en la pestaña PLANES, desde donde podrás gestionar y contratar la suscripción para tu empresa.</p>
                      <p>El Plan Best Fit permite al usuario recibir los contenidos especializados en Transformación Digital y  ser parte de una guía de proveedores segmentada y rankeada dentro de un nuevo canal de negocios con clientes que buscan servicios en transformación. Además, tendrás acceso a presentar cantidad ilimitada de licitaciones, contando con el beneficio de un PMO online en Transformación Digital, que acompañará y monitoreará sus proyectos.</p>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="tway-font-expansion-panel">
              Soy Especialista y estoy en el Plan Starter, ¿Cómo puedo suscribirme al Plan Business?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <v-layout row>
                  <v-flex :class="mobile ? 'mb-5' : 'px-4'" xs12 md3>
                    <v-layout>
                      <v-img
                        :src="require('@/assets/images/starter.svg')"
                        contain
                        width="200"
                        max-height="140"
                      />
                    </v-layout>
                  </v-flex>
                  <v-flex :class="mobile ? 'px-4' : ''" xs12 md9>
                    <div class="tway-body grey--text text--darken-3">
                      <p>El Plan Business estará disponible en la pestaña PLANES, desde donde podrás contratar y gestionar la suscripción para tu empresa.</p>
                      <p>El Plan Business es una oportunidad para las empresas que desean acceder a un nuevo canal de ventas y promoción, ya que permite a los Especialistas pertenecer a una guía sectorial de proveedores de Transformación Digital rankeada y segmentada, otorgándole acceso a Clientes que buscan servicios, productos y herramientas en transformación. Además, tendrán acceso a presentar una licitación trimestral, contando con el beneficio de un PMO online en Transformación Digital, modelo exclusivo de trabajo Tway, que acompañará y monitoreará sus proyectos. Este Plan también contempla recibir contenidos especializados en Transformación Digital.</p>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="tway-font-expansion-panel">
              Soy Cliente y estoy en el Plan Starter, ¿Cómo puedo suscribirme al Plan Best Fit?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <v-layout row>
                  <v-flex :class="mobile ? 'mb-5' : 'px-4'" xs12 md3 order-md2>
                    <v-layout>
                      <v-img
                        :src="require('@/assets/images/cliente.svg')"
                        contain
                        width="200"
                        max-height="140"
                      />
                    </v-layout>
                  </v-flex>
                  <v-flex :class="mobile ? 'px-4' : ''" xs12 md9 order-md1>
                    <div :class="mobile ? '' : 'text-right'" class="tway-body grey--text text--darken-3">
                      <p>El Plan Best Fit es el paquete de beneficios más completo en Tway y estará disponible en la pestaña PLANES, desde donde podrás contratar y gestionar la suscripción para tu empresa.</p>
                      <p>El Plan Best Fit permite a la empresa recibir los contenidos especializados en Transformación Digital, recibir el diagnóstico del Indice de Madurez en Transformación Digital para conocer sus brechas y acceder a los proveedores que conforman nuestra Guía Sectorial rankeada y segmentada. Además, tendrás acceso a presentar cantidad ilimitada de licitaciones, donde le presentaremos las mejores alternativas de proveedores para generar un match de alta precisión o Best Fit, que aumenta las eficiencias y reduce riesgos para la empresa. El proyecto contará con el beneficio de un PMO online en Transformación Digital, modelo de trabajo exclusivo Tway, que acompañará y monitoreará este proyecto.</p>
                      <p>Si el Cliente así lo desea, podrá contratar adicionalmente el servicio de Orquestación, que busca ayudar a articular todos los elementos de la compañía para gestionar y dirigir el cambio</p>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
           <v-expansion-panel>
            <v-expansion-panel-header class="tway-font-expansion-panel">
              Soy Cliente y estoy en el Plan Starter, ¿Cómo puedo suscribirme al Plan Business?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <v-layout row>
                  <v-flex :class="mobile ? 'mb-5' : 'px-4'" xs12 md3 order-md2>
                    <v-layout>
                      <v-img
                        :src="require('@/assets/images/team-building.svg')"
                        contain
                        width="200"
                        max-height="140"
                      />
                    </v-layout>
                  </v-flex>
                  <v-flex :class="mobile ? 'px-4' : ''" xs12 md9 order-md1>
                    <div :class="mobile ? '' : 'text-right'" class="tway-body grey--text text--darken-3">
                      <p>El Plan Business está disponible en la pestaña PLANES, desde donde podrás contratar y gestionar la suscripción para tu empresa.</p>
                      <p>Con este paquete las compañías reciben contenidos especializados en Transformación Digital.  Además, para conocer su estatus en Transformación y brechas se les hace un diagnóstico a partir del Indice de Madurez en Transformación Digital y acceder a acceder a los proveedores que conforman nuestra Guía Sectorial rankeada y segmentada, pudiendo presentar un proyecto trimestral de licitación. Así, la empresa recibirá alternativas de proveedores a la medida para generar un match de alta precisión o Best Fit, que aumenta las eficiencias y reduce riesgos. Ese proyecto contará con el beneficio de un PMO online en Transformación Digital, modelo de trabajo exclusivo Tway que acompañará y monitoreará este proyecto.</p>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    mobile () {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs;
    }
  }
};
</script>

<style>
.tway-font-expansion-panel {
  font-family: 'Josefin Sans', sans-serif;
  font-style: normal;
  font-weight: normal!important;
  font-size: 21px!important;
  line-height: 21px!important;
}

.how-to-begin {
  background: #e9e3ef;
  padding-top: 100px;
  padding-bottom: 100px;
}

.about-plans {
  padding-top: 100px;
  padding-bottom: 100px;
}

.text-col {
  max-width: 820px;
}
</style>
